var map = {
	"./00004621.jpg": 418,
	"./00005520.jpg": 879,
	"./00005520_original.jpg": 57,
	"./cn.png": 156,
	"./de.png": 114,
	"./es.png": 87,
	"./fr.png": 987,
	"./gb.png": 748,
	"./it.png": 540,
	"./logo_wika.svg": 227,
	"./pl.png": 423,
	"./pt.png": 759,
	"./wikaLogo.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;